import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { map } from 'rxjs/operators';
import { IDtoEmployeeFilter } from 'app/shared/models/request/holiday/dto-employee-filter.model';
import { IDtoEmployee } from 'app/shared/models/employee/dto-employee.model';
import { IResult } from 'app/shared/models/result.model';
import { IDtoHoliday } from 'app/shared/models/request/holiday/dto-holiday.model';

@Injectable()
export class HolidayService {
    private requestUrl = '';
    private recruitmentUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
            this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x => {
                this.requestUrl = this.configurationService.serverSettings.requestUrl;
                this.recruitmentUrl = this.configurationService.serverSettings.recruitmentUrl;
            });
        }
    }
    public getCatalogEmployeesByFilter(list: IDtoEmployeeFilter): Observable<ISelect[]> {
        const url =`${this.requestUrl}api/Employees/getCatalogsEmployeesByFilter/`;
        return this.service.post(url, list).pipe(map((response: any) => {
            return response;
        }));
    }
    public getEmployeesByBoss(bossId: string): Observable<ISelect[]> {
        const url =`${this.recruitmentUrl}api/Employees/getEmployeesByBoss?bossId=${bossId}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }   
    public getEmployeeData(id: string): Observable<IResult> {
        const url = `${this.requestUrl}api/employees/getEmployeesById?id=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getHolidayRequestsByEmployeeId(id: string, requisitionId: number): Observable<IResult> {
        const url = `${this.requestUrl}api/Holidays/GetListHolidayRequestsByEmployeeId?employeeId=${id}&requisitionId=${requisitionId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getHolidayLaborOldByEmployeeId(id: string): Observable<IResult> {
        const url = `${this.requestUrl}api/Holidays/GetListHolidayLaborOldByEmployeeId?employeeId=${id}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addHoliday(holiday: IDtoHoliday): Observable<IResult> {
        const url =`${this.requestUrl}api/Holidays/`;
        return this.service.post(url, holiday).pipe(map((response: any) => {
            return response;
        }));
    }
    public updateHoliday(holiday: IDtoHoliday): Observable<IResult> {
        const url =`${this.requestUrl}api/Holidays/`;
        return this.service.putWithId(url, holiday).pipe(map((response: any) => {
            return response;
        }));
    }
    public getHolidaysRequest(list: IDtoEmployeeFilter): Observable<IResult> {
        const url =`${this.requestUrl}api/holidays/getRequestHolidays/`;
        return this.service.post(url, list).pipe(map((response: any) => {
            return response;
        }));
    } 
    public getCatalogRequestStatus(): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/holidays/getCatalogStatus/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogFederalHoliday(): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/FederalHolidays/getCatalogFederalHoliday/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
}
